export default __webpack_public_path__ + "static/media/V.063a9584.svg";